module.exports = __webpack_public_path__ + "5419df5b7775575728a3bd911d55a03a.svg";